/**
 * 极简 hash 路由。**五个固定标签页用不着 react-router。**
 *
 * 为什么用 hash 而不是 history：大厅会被塞进 webview、也可能挂在别人的
 * 子路径下，hash 不需要服务端配 fallback，换个部署位置不会 404。
 *
 * 纯函数放这里、订阅放 hook 里 —— 这样解析逻辑能用 node:test 直接测。
 */

export const TABS = ['lobby', 'activity', 'agent', 'deposit', 'profile'] as const;
export type Tab = (typeof TABS)[number];
export const DEFAULT_TAB: Tab = 'lobby';

export function isTab(v: unknown): v is Tab {
  return typeof v === 'string' && (TABS as readonly string[]).includes(v);
}

/**
 * `#/deposit?x=1` -> `deposit`。**认不出来的一律回默认页**，不是白屏 ——
 * 用户可能存了旧版本的链接，也可能是别人乱发的。
 */
export function tabFromHash(hash: string): Tab {
  const path = String(hash || '').replace(/^#/, '').split('?')[0];
  const first = path.split('/').filter(Boolean)[0];
  return isTab(first) ? first : DEFAULT_TAB;
}

export function hashFor(tab: Tab): string {
  return `#/${tab}`;
}
